import React, { useEffect, useState } from 'react';
import { Typography, TextField } from '@mui/material';
import './detailTalent.css';

const EditableField = ({ label, field, isEditing, multiline = false, value, onChange }) => {
  const isDateField = field === 'disponibilite';
  const [inputValue, setInputValue] = useState(value || '');

  useEffect(() => {
    setInputValue(value || '');
  }, [value, isEditing]);

  const handleCommit = () => {
    if (inputValue !== value) {
      onChange(field, inputValue);
    }
  };

  const handleKeyUp = (e) => {
    if (e.key === 'Enter' && !multiline) {
      e.preventDefault();
      handleCommit();
      e.target.blur();
    }
  };

  const isValueEmpty = [null, undefined, 'undefined', '""'].includes(value) || (typeof value === 'string' && value.trim() === '');

  if (!isEditing && isValueEmpty) {
    return (
      <div className="editable-field">
        <Typography variant="subtitle2" className="label-text">{label}</Typography>
        <Typography variant="body1" className="value-text">Non renseigné</Typography>
      </div>
    );
  }

  return (
    <div className="editable-field">
      <Typography variant="subtitle2" className="label-text">{label}</Typography>
      {isEditing ? (
        <TextField
          fullWidth
          multiline={multiline}
          minRows={multiline ? 2 : 1}
          type={isDateField ? 'date' : 'text'}
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          onBlur={handleCommit}
          onKeyUp={handleKeyUp}
        />
      ) : (
        <Typography variant="body1" className="value-text">
          {isDateField && value ? new Date(value).toLocaleDateString('fr-FR') : value}
        </Typography>
      )}
    </div>
  );
};

export default EditableField;
